export enum ConfigurationViewProperties {
  dialogDeleteWidth = '650px'
}
